const APPS_HOST_SUFFIX = '.apps.alta.avigilon.com';
const WEAR_HOST = 'wear.alta.avigilon.com';
const WEAR_HOST_SUFFIX = `.${WEAR_HOST}`;
const DAVINCI_PATH = '/apps/davinci';

export const isWearRedirectUrl = (redirectUrl?: string): boolean => {
  if (!redirectUrl) return false;

  try {
    const { hostname, pathname, protocol } = new URL(redirectUrl);

    if (protocol !== 'https:') return false;

    if (hostname === WEAR_HOST || hostname.endsWith(WEAR_HOST_SUFFIX)) {
      return true;
    }

    return (
      hostname.endsWith(APPS_HOST_SUFFIX) &&
      (pathname === DAVINCI_PATH || pathname.startsWith(`${DAVINCI_PATH}/`))
    );
  } catch {
    return false;
  }
};
